import { onDoctypes, removeListener } from "api/prokey/prokey.websocket";
import React, { createContext, useEffect, useState } from "react"

const TaskContext = createContext()

//-----------------------------------------------------------------
function TaskProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ task    , setTask     ] = useState( {} );
  const [ doctypes, setDoctypes ] = useState( {} );

  const values = {
    task     , setTask ,
    doctypes ,
  };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleDoctypes(data) {
      //-----------------------------------------------------------------
      setDoctypes( data );
    }

    onDoctypes  ( handleDoctypes );

    return () => {
      removeListener( 'DOCTYPES'   , handleDoctypes   );
    };
  }, [] );

  //#endregion

  return (
    <TaskContext.Provider value={ values }>
      {children}
    </TaskContext.Provider>
  );
};

export { TaskContext, TaskProvider };